// extracted by mini-css-extract-plugin
export default {"homeContent__top":"c-i_ea","homeContent__bottom":"c-i_eb","homeContent__cardHolder":"c-i_ec","homeContent__seoTextHolder":"c-i_ee"};